import React from 'react';
import { useSearchParams } from 'react-router-dom';
import SearchIcon from '../../../assets/icons/actions/SearchIcon';

const MenuBarSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const onClickSearch = (): void => {
    searchParams.append('search', '');
    setSearchParams(searchParams);
  };

  return (
    <button
      className="size-8 border rounded-full flex justify-center items-center shrink-0 dark:shadow-none"
      onClick={onClickSearch}
    >
      <SearchIcon className="size-4" />
    </button>
  );
};

export default MenuBarSearch;
